import { device } from "shared/constants/device";
import styled from "styled-components";

export const Aside = styled.aside`
  width: 230px;
  margin-right: 10px;
  ul {
    margin: 0px;
    padding: 0px;
    list-style: none;
    font-size: 13px;
    li{
      &:hover,&:focus, &.active{
        background-color: rgb(235, 235, 240);
        color: rgb(0, 0, 0);
      }
      .arrow__right{
        display:none;
      }
      .icon__left{
        margin-right: 10px;
        filter: var(--color-fill-primary);
      }
    }
    a,button {
      display: flex;
      width: 100%;
      -webkit-box-align: center;
      align-items: center;
      padding: 7px 18px;
      color: rgb(74, 74, 74);
      outline:none;
      border:none;
      background:transparent;
    
      svg {
        width:16px !important;
        height: auto;
        margin: 0px 22px 0px 0px;
        font-size: 17px;
        color: rgb(155, 155, 155);
      }
    }
  }
  @media ${device.tablet} {
    width: 100%;
    margin-right:0px;
    ul{
      background:#fff;
      li{
        border-bottom: 1px solid rgb(235, 235, 240);
        position:relative;
        a{
          padding: 10px 18px;
        }

        .arrow__right{
          display:block;
          position:absolute;
          top:10px;
          right:5px;
        }
      }
    }
  }
`;
export const AvatarContainer = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding-left: 7px;
  margin: 0px 0px 12px;
  .avatar{
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    text-transform: uppercase;
    background:#fff;
    margin-right:10px;
  }
  .info {
    flex: 1 1 0%;
    font-size: 13px;
    line-height: 15px;
    color: rgb(51, 51, 51);
    font-weight: 300;
  }
  img {
    margin-right: 5px;
    width: 45px;
    margin: 0px 12px 0px 0px;
    border-radius: 50%;
  }
`;
